module.exports = __webpack_public_path__ + "img/BOCmaster-compressor.ab6edf0c.png";